import { Box } from '@mui/material';
import { ReactElement } from 'react';
import {
  DataTable,
  ListContextProvider,
  ResourceContextProvider,
  useList,
  useStore,
  type SortPayload,
} from 'react-admin';
import { supportedDateFormats } from '../../../../Components/TzDate/utils';
import { reportDataTableSx } from '../../../../Components/ReportsWidget/utils';
import type { ActionLogsByUsersResource } from '../../../../Entities/ActionLogsByUser';
import ActionLogsByUserChart from './ActionLogsByUserChart';
import { formatActionLogReportDate } from './utils';

interface ActionLogsByUserDataTableProps {
  data: ActionLogsByUsersResource[];
  isPending?: boolean;
  sort?: SortPayload;
}

export default function ActionLogsByUserDataTable({
  data,
  isPending = false,
  sort,
}: ActionLogsByUserDataTableProps): ReactElement {
  const [dateFormat] = useStore('format.date', supportedDateFormats[0].id);
  const listContext = useList<ActionLogsByUsersResource>({
    data,
    isPending,
    sort,
    perPage: Math.max(data.length, 1),
  });

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <ListContextProvider value={listContext}>
        <ResourceContextProvider value="action_logs_by_users">
          {!isPending && <ActionLogsByUserChart />}
          <DataTable rowClick={false} bulkActionButtons={false} size="small" sx={reportDataTableSx}>
            <DataTable.Col
              source="attributes.date"
              label="Date"
              render={(record) => formatActionLogReportDate(record.attributes?.date, dateFormat)}
            />
            <DataTable.Col
              label="User"
              render={(record) =>
                record.attributes?.user_identifier || record.attributes?.user_id || ''
              }
            />
            <DataTable.Col source="attributes.count" label="Count" />
          </DataTable>
        </ResourceContextProvider>
      </ListContextProvider>
    </Box>
  );
}
